"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pBoolFromData = void 0;
var types_1 = require("../../../type_system/types.js");
var data_1 = require("../../builtins/data/index.js");
var phoist_1 = require("../../phoist.js");
var plam_1 = require("../../plam.js");
exports.pBoolFromData = (0, phoist_1.phoist)((0, plam_1.plam)(types_1.data, types_1.bool)(function (d) { return data_1.punConstrData.$(d).fst.eq(0); }, "pBoolFromData"));
